import React from "react";
import LandingPageBody from "../landingPage/LandingPageBody";
import Footer from "../footer/Footer";
import { FooterCarousel } from "../footer/FooterCarousel";

const Home = () => {
  return (
    <div>
      <LandingPageBody />
      <FooterCarousel />
      <hr />
      <Footer />
    </div>
  );
};

export default Home;
